import {BaseService} from "./base.service";

class AdminsService extends BaseService {

    constructor() {
        super('api/administrators')
    }

}

export const adminsService = new AdminsService();
